'use strict';

var React = require('react');

var SvgBuyButtonMajor = function SvgBuyButtonMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M0 1.5a1.5 1.5 0 0 1 1.5-1.5h17a1.5 1.5 0 0 1 1.5 1.5v6a1.5 1.5 0 0 1-1.5 1.5h-5.889a1.5 1.5 0 0 1-1.5-1.5v-2.389a1.111 1.111 0 1 0-2.222 0v2.389a1.5 1.5 0 0 1-1.5 1.5h-5.889a1.5 1.5 0 0 1-1.5-1.5v-6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 5a3 3 0 0 1 6 0v4.384a.5.5 0 0 0 .356.479l2.695.808a2.5 2.5 0 0 1 1.756 2.748l-.633 4.435a2.5 2.5 0 0 1-2.475 2.146h-7.739a2.5 2.5 0 0 1-2.27-1.452l-2.06-4.464a2.417 2.417 0 0 1-.106-1.777c.21-.607.719-1.16 1.516-1.273 1.035-.148 2.016.191 2.961.82v-6.854zm3-1a1 1 0 0 0-1 1v7.793c0 1.39-1.609 1.921-2.527 1.16-.947-.784-1.59-.987-2.069-.948a.486.486 0 0 0 .042.241l2.06 4.463a.5.5 0 0 0 .454.291h7.74a.5.5 0 0 0 .494-.43l.633-4.434a.5.5 0 0 0-.35-.55l-2.695-.808a2.5 2.5 0 0 1-1.782-2.394v-4.384a1 1 0 0 0-1-1z"
  }));
};

exports.SvgBuyButtonMajor = SvgBuyButtonMajor;
